import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

/*
Services only last for the duration of the page, after that they are free'd and recreated as needed.  Data must be stored
in sessions or local store to persist.
*/


@Injectable({
    providedIn: 'root'
})
export class LoginService {
    loginConfig: LoginConfig;

    constructor( private http: HttpClient, private router: Router ) {
        console.log(">>>>> Create login.service");
        this.loadLoginConfig();
    }

    login( code: string ) {
        const formData: FormData = new FormData();
        const endPoint = 'http://herenow.live/service.php';

        console.log("LoginService.login()");

        formData.append('action', 'login');
        formData.append('code', code);

        
        return this.http
            .post(endPoint, formData).subscribe (
                (res) => {
                    console.log("LoginService.login()");
                    console.log(res);
                    this.setLoginConfig(<LoginConfig>res);
        
                    if (res['response'] === 0) {
                        //this.router.navigate(['/loading']);
                        this.router.navigate(['/welcome']);
                    } else {
                        this.router.navigate(['/']);
                    }

                },
                (err) => {
                    console.log(err)
                }
            );
    }

    setLoginConfig(loginConfig: LoginConfig) {
        this.loginConfig = loginConfig;
        this.saveLoginConfig();
    }

    saveLoginConfig() {
        sessionStorage.loginConfig = JSON.stringify(this.loginConfig);
    }

    loadLoginConfig() {
        this.loginConfig = JSON.parse(sessionStorage.getItem("loginConfig"));
    }

    loginFail() {
        return (this.loginConfig.response == 1);
    }

    loginWarn() {
        return (this.loginConfig.response == 2);
    }

    /*** SETTERS and GETTERS */
    setTeamName(name: string) {
        this.loginConfig.teamName = name;
        this.saveLoginConfig();
    }

    getTeamName() {
        return this.loginConfig.teamName;
    }

    getTeamId() {
        return this.loginConfig.teamId;
    }

    setEventName(name: string) {
        this.loginConfig.eventName = name;
        this.saveLoginConfig();
    }

    getEventName() {
        return this.loginConfig.eventName;
    }

    getEventId() {
        return this.loginConfig.eventId;
    }

    getError() {
        return this.loginConfig.error;
    }
/*
    setTeamCode(code: string) {
        this.loginConfig.teamCode = code;
        sessionStorage.teamCode = code;
    }

    getTeamCode() {
        return this.loginConfig.teamCode;
    }
*/
}

export interface LoginConfig {
    eventId: number;
    eventName: string;
    teamId: number;
    teamName: string;
    supportEmail: string;
    css: string;
    response: number;
    error: string;
}